import { supabase } from '@/integrations/supabase/client';

export interface VideoByAssetResult {
  id: string;
  mux_asset_id: string;
  mux_playback_id?: string;
  status: string;
  user_id: string;
}

/**
 * Find video record by Mux asset ID
 */
export async function getVideoByAssetId(assetId: string): Promise<{ data: VideoByAssetResult | null, error: any }> {
  const { data: { user }, error: authError } = await supabase.auth.getUser();
  
  if (authError || !user) {
    return { data: null, error: authError || new Error('Not authenticated') };
  }

  try {
    // First try the compound query
    const { data, error } = await supabase
      .from('videos')
      .select('id, mux_asset_id, mux_playback_id, status, user_id')
      .eq('mux_asset_id', assetId)
      .eq('user_id', user.id)
      .maybeSingle();

    if (error) {
      console.error('Error with compound query:', error);
      
      // Fallback: Query by asset ID only, then verify user_id in code
      const { data: fallbackData, error: fallbackError } = await supabase
        .from('videos')
        .select('id, mux_asset_id, mux_playback_id, status, user_id')
        .eq('mux_asset_id', assetId)
        .maybeSingle();
      
      if (fallbackError) {
        return { data: null, error: fallbackError };
      }
      
      // Verify ownership
      if (fallbackData && fallbackData.user_id === user.id) {
        return { data: fallbackData, error: null };
      } else {
        return { data: null, error: new Error('Video not found or access denied') };
      }
    }

    return { data, error };
  } catch (err) {
    console.error('Unexpected error in getVideoByAssetId:', err);
    return { data: null, error: err };
  }
}
